module.exports = __webpack_public_path__ + "images/manage_imports.svg";